
import Divisor from './Divisor';
import TituloNegrito from './TituloNegrito';

import Image from 'react-bootstrap/Image';

import header from '../images/a2a2-header.png'

import constantes from '../helpers/constanteHelper';

function DetalhesCertificacaoA2A2({ produtos, exibirMenu, resolucaoMobile }) {
    return (
        <>
            <Divisor />
            <TituloNegrito texto={'Certificação Vacas A2A2'} />
            <Image style={{ height: '400px', objectFit: 'contain', padding: '20px' }} src={header} alt='logo' fluid />
            <span className='mt-4 mb-5' style={{ width: resolucaoMobile ? '90vw' : '70vw', color: constantes.CORES.BRANCO_PADRAO, fontSize: resolucaoMobile ? '16px' : '20px', textAlign: resolucaoMobile ? 'justify' : 'center', whiteSpace: 'pre-line' }}>
                A Certificação Vacas A2A2 é independente e de adesão voluntária.<br /><br />
                O Programa utiliza a Certificação de Terceira Parte, que tem como objetivo verificar se um determinado sistema de gerenciamento ou procedimento foi estabelecido, está documentado, implementado e mantido de acordo com normas e escopos específicos.<br /><br />
                Este programa foi baseado em pesquisas desenvolvidas por Universidades e Instituições brasileiras e internacionais. As auditorias são feitas por entidades certificadoras acreditadas internacionalmente, pelo International Accreditation Forum (IAF).<br /><br />
                O programa de Certificação Vacas A2A2 foi o primeiro protocolo de rastreabilidade da pecuária leiteira registrado da Confederação Nacional da Agricultura (CNA), o que garante ainda mais robustez, transparência e confiabilidade ao mercado de leite proveniente de Vacas A2A2 no Brasil.<br /><br />
            </span>
        </>
    );
}
export default DetalhesCertificacaoA2A2;
